import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const regionAPI = {
    getRegions: (params) => axios.get(`${API_URL}/api/regions`, { params }),
    getRegion: (id) => axios.get(`${API_URL}/api/admin/regions/${id}`),
    createRegion: (data) => axios.post(`${API_URL}/api/admin/regions`, data),
    updateRegion: (id, data) => axios.put(`${API_URL}/api/admin/regions/${id}`, data),
    deleteRegion: (id) => axios.delete(`${API_URL}/api/admin/regions/${id}`),
};
